import Repository from './Repository';
import {AxiosResponse} from "axios";
import Province from "@/models/province.models";
import District from "@/models/district.models";
import Ward from "@/models/Ward.models";

const resource = '/location';

export default new class{
    getProvince(): Promise<AxiosResponse<Province[]>>{
        return Repository.get<Province[]>(`${resource}/province`);
    }

    getDistrict(id: number): Promise<AxiosResponse<District[]>>{
        return Repository.get<District[]>(`${resource}/district/${id}`);
    }

    getWard(id: number): Promise<AxiosResponse<Ward[]>>{
        return Repository.get<Ward[]>(`${resource}/ward/${id}`);
    }
}
